import RejectionModal from './RejectionModal.container'
export default RejectionModal
